import React, { useEffect } from 'react'
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';
import GiveExam from '../assets/exam-ians.jpg';
import CheckExam from '../assets/How-to-prepare-for-English-Olympiad.png';
import CareerPath from '../assets/career-path.jpg';
import OnlineLearning from '../assets/1686257411381.jpg';
import AOS from "aos";
import "aos/dist/aos.css";

const StudentPanel = () => {
    const navigation = useNavigate();
      useEffect(() => {
        AOS.init({ duration: "1000" });
      });
  return (
    <div className="Admin">
      <Navbar />
      <div className="flex flex-col min-h-screen justify-center items-center">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div
            className="transition ease-in-out delay-150 max-w-lg rounded shadow-lg bg-blue-300 m-3 hover:scale-100 duration-200"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <img
              className="rounded-t-lg transition-all duration-300 rounded-lg cursor-pointer object-cover"
              src={GiveExam}
              alt=""
            />

            <div className="p-5">
              <h5 className="mb-2 text-2xl font-bold tracking-tight ">
                Give Exam
              </h5>

              <p class="mb-3 font-normal">
                {" "}
                In this Panel Give Exam to get Evaluate
              </p>
              <button
                onClick={() => navigation("/Assign_Teacher")}
                class="w-full px-3 py-2 text-xl font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Click
              </button>
            </div>
          </div>

          <div
            className="transition ease-in-out delay-150 max-w-lg w-full rounded shadow-lg bg-blue-300 m-3 hover:scale-100 duration-200"
            data-aos="fade-left"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <img
              className="rounded-t-lg transition-all duration-300 rounded-lg cursor-pointer object-cover"
              src={CheckExam}
              alt=""
            />

            <div className="p-5">
              <h5 className="mb-2 text-2xl font-bold tracking-tight ">
                Check Marks
              </h5>

              <p class="mb-3 font-normal">In this Panel Check your Marks</p>
              <button
                onClick={() => navigation("/Enroll_Student_Course")}
                class="w-full px-3 py-2 text-xl font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Click
              </button>
            </div>
          </div>

          <div
            className="transition ease-in-out delay-150 max-w-lg w-full rounded shadow-lg bg-blue-300 m-3 hover:scale-100 duration-200"
            data-aos="fade-right"
          >
            <img
              className="rounded-t-lg transition-all duration-300 rounded-lg cursor-pointer object-cover"
              src={CareerPath}
              alt=""
            />

            <div className="p-5">
              <h5 className="mb-2 text-2xl font-bold tracking-tight ">
                Career Path
              </h5>

              <p class="mb-3 font-normal">
                In this Panel Check Your Career Path
              </p>
              <button
                onClick={() => navigation("/Enroll_Student_Course")}
                class="w-full px-3 py-2 text-xl font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Click
              </button>
            </div>
          </div>

          <div
            className="transition ease-in-out delay-150 max-w-lg w-full rounded shadow-lg bg-blue-300 m-3 hover:scale-100 duration-200"
            data-aos="fade-left"
          >
            <img
              className="rounded-t-lg transition-all duration-300 rounded-lg cursor-pointer object-cover"
              src={OnlineLearning}
              alt=""
            />

            <div className="p-5">
              <h5 className="mb-2 text-2xl font-bold tracking-tight ">
                Online Learning
              </h5>

              <p class="mb-3 font-normal">
                In this Panel Check All the Online Learning Platform
              </p>
              <button
                onClick={() => navigation("/Enroll_Student_Course")}
                class="w-full px-3 py-2 text-xl font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Click
              </button>
            </div>
          </div>

          {/*        <div
                  onClick={() => navigation("/add-job")}
                  className="transition ease-in-out delay-150 max-w-lg w-full rounded shadow-lg bg-gray-300 m-3 hover:scale-110 duration-200"
                >
                  <h2 className="text-2xl text-center px-6 py-6">
                    Job Positions
                  </h2>
</div> */}

          {/*        <div
                  onClick={() => navigation("/add-skill")}
                  className="transition ease-in-out delay-150 max-w-lg w-full rounded shadow-lg bg-gray-300 m-3 hover:scale-110 duration-200"
                >
                  <h2 className="text-2xl text-center px-6 py-6">
                    Set Competency
                  </h2>
</div> */}
        </div>
      </div>
    </div>
  );
}

export default StudentPanel
